import { Container, ContainerProps, styled } from '@mui/material';
import React, { forwardRef } from 'react';

const StyledContainer = styled(Container)(({ theme: { breakpoints, spacing } }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  maxWidth: `${breakpoints.values.xl}px`,
  marginInline: 'auto',
  width: '100%',
  boxSizing: 'border-box',
  paddingInline: spacing(2),
  [breakpoints.up('sm')]: {
    paddingInline: spacing(3),
  },
  [breakpoints.up('md')]: {
    paddingInline: spacing(4),
  },
}));

export const AppWrapper = forwardRef<HTMLDivElement, ContainerProps>((props, ref) => (
  <StyledContainer ref={ref} maxWidth={false} disableGutters {...props} />
));
